// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/custody/v1/custody.proto (package penumbra.custody.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { AuthorizationData, TransactionPlan } from "../../core/transaction/v1/transaction_pb.js";
import { Validator } from "../../core/component/stake/v1/stake_pb.js";
import { SpendAuthSignature } from "../../crypto/decaf377_rdsa/v1/decaf377_rdsa_pb.js";
import { ValidatorVoteBody } from "../../core/component/governance/v1/governance_pb.js";
import { Address, AddressIndex, FullViewingKey } from "../../core/keys/v1/keys_pb.js";

/**
 * @generated from message penumbra.custody.v1.AuthorizeRequest
 */
export const AuthorizeRequest = proto3.makeMessageType(
  "penumbra.custody.v1.AuthorizeRequest",
  () => [
    { no: 1, name: "plan", kind: "message", T: TransactionPlan },
    { no: 3, name: "pre_authorizations", kind: "message", T: PreAuthorization, repeated: true },
  ],
);

/**
 * @generated from message penumbra.custody.v1.AuthorizeResponse
 */
export const AuthorizeResponse = proto3.makeMessageType(
  "penumbra.custody.v1.AuthorizeResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: AuthorizationData },
  ],
);

/**
 * @generated from message penumbra.custody.v1.AuthorizeValidatorDefinitionRequest
 */
export const AuthorizeValidatorDefinitionRequest = proto3.makeMessageType(
  "penumbra.custody.v1.AuthorizeValidatorDefinitionRequest",
  () => [
    { no: 1, name: "validator_definition", kind: "message", T: Validator },
    { no: 3, name: "pre_authorizations", kind: "message", T: PreAuthorization, repeated: true },
  ],
);

/**
 * @generated from message penumbra.custody.v1.AuthorizeValidatorDefinitionResponse
 */
export const AuthorizeValidatorDefinitionResponse = proto3.makeMessageType(
  "penumbra.custody.v1.AuthorizeValidatorDefinitionResponse",
  () => [
    { no: 1, name: "validator_definition_auth", kind: "message", T: SpendAuthSignature },
  ],
);

/**
 * @generated from message penumbra.custody.v1.AuthorizeValidatorVoteRequest
 */
export const AuthorizeValidatorVoteRequest = proto3.makeMessageType(
  "penumbra.custody.v1.AuthorizeValidatorVoteRequest",
  () => [
    { no: 1, name: "validator_vote", kind: "message", T: ValidatorVoteBody },
    { no: 3, name: "pre_authorizations", kind: "message", T: PreAuthorization, repeated: true },
  ],
);

/**
 * @generated from message penumbra.custody.v1.AuthorizeValidatorVoteResponse
 */
export const AuthorizeValidatorVoteResponse = proto3.makeMessageType(
  "penumbra.custody.v1.AuthorizeValidatorVoteResponse",
  () => [
    { no: 1, name: "validator_vote_auth", kind: "message", T: SpendAuthSignature },
  ],
);

/**
 * A pre-authorization packet.  This allows a custodian to delegate (partial)
 * signing authority to other authorization mechanisms.  Details of how a
 * custodian manages those keys are out-of-scope for the custody protocol and
 * are custodian-specific.
 *
 * @generated from message penumbra.custody.v1.PreAuthorization
 */
export const PreAuthorization = proto3.makeMessageType(
  "penumbra.custody.v1.PreAuthorization",
  () => [
    { no: 1, name: "ed25519", kind: "message", T: PreAuthorization_Ed25519, oneof: "pre_authorization" },
  ],
);

/**
 * An Ed25519-based preauthorization, containing an Ed25519 signature over the
 * `TransactionPlan`.
 *
 * @generated from message penumbra.custody.v1.PreAuthorization.Ed25519
 */
export const PreAuthorization_Ed25519 = proto3.makeMessageType(
  "penumbra.custody.v1.PreAuthorization.Ed25519",
  () => [
    { no: 1, name: "vk", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "sig", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
  {localName: "PreAuthorization_Ed25519"},
);

/**
 * @generated from message penumbra.custody.v1.ExportFullViewingKeyRequest
 */
export const ExportFullViewingKeyRequest = proto3.makeMessageType(
  "penumbra.custody.v1.ExportFullViewingKeyRequest",
  [],
);

/**
 * @generated from message penumbra.custody.v1.ExportFullViewingKeyResponse
 */
export const ExportFullViewingKeyResponse = proto3.makeMessageType(
  "penumbra.custody.v1.ExportFullViewingKeyResponse",
  () => [
    { no: 1, name: "full_viewing_key", kind: "message", T: FullViewingKey },
  ],
);

/**
 * @generated from message penumbra.custody.v1.ConfirmAddressRequest
 */
export const ConfirmAddressRequest = proto3.makeMessageType(
  "penumbra.custody.v1.ConfirmAddressRequest",
  () => [
    { no: 1, name: "address_index", kind: "message", T: AddressIndex },
  ],
);

/**
 * @generated from message penumbra.custody.v1.ConfirmAddressResponse
 */
export const ConfirmAddressResponse = proto3.makeMessageType(
  "penumbra.custody.v1.ConfirmAddressResponse",
  () => [
    { no: 1, name: "address", kind: "message", T: Address },
  ],
);

